import { Alert, Button, Text } from '@mantine/core';
import { AlertCircle } from 'react-feather';
import { schedulingTokens as tokens } from './schedulingTokens';

export const AVAILABILITY_FAILED_MESSAGE =
  'We could not load open times. Please try again.';

interface AvailabilityFailureAlertProps {
  /** The sentence that says why no open times loaded. */
  message?: string;
  /** Loads the visible month again. */
  onRetry: () => void;
}

/**
 * The notice when no open times loaded for the visible month. Pass it as
 * the SlotPicker `topStatus`, so it sits above the grid that it explains.
 * The public page and both participant modals use this one component, so
 * the three surfaces show the same notice.
 */
export function AvailabilityFailureAlert({
  message = AVAILABILITY_FAILED_MESSAGE,
  onRetry,
}: AvailabilityFailureAlertProps) {
  return (
    <Alert
      color="dangerRed.5"
      variant="light"
      icon={<AlertCircle size={16} />}
      mb="md"
      role="alert"
      styles={{ message: { color: tokens.textPrimary } }}
    >
      <Text size="sm">{message}</Text>
      <Button
        size="sm"
        mt="sm"
        onClick={onRetry}
        style={{ backgroundColor: tokens.primary, border: 'none' }}
      >
        Try again
      </Button>
    </Alert>
  );
}
